import React, { Component, useEffect, useState, useRef } from "react";
import { Tab, Col, Row, Card } from "react-bootstrap";
import InfoHeader from "../comman/infoHeader";
import Pagination from "../comman/pagination";
import { paginate, calculateIndex } from "../utlis/paginate";
import GenerateExcel from "./GenerateExcel";
import GeneratePdf from "./GeneratePdf";
import jsPDF from "jspdf";
import "jspdf-autotable";
import PieChart from "../Charts/pie";
import BarChart from "../Charts/bar";
import { getAllYears, getMonthName } from "../services/appService";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPageTitle, setCurrentRoute } from "../app/store/layoutUI";
import { getDataTypeApplicationReports, loadDataTypeApplicationReports } from "../app/store/reports";
import { getAllCandidateList, loadAllCandidateList } from "../app/store/candidate";
import { getApplicationReportPartnerStats, getPartnerListByType, loadApplicationReportPartnerStats, loadPartnerListByType } from "../app/store/partner";

const ApplicationReport = () => {
  const route = [{ name: "Analytics", url: "" }];

  const [reportData, setReportData] = useState([]);
  const [allReportData, setAllReportData] = useState([]);
  const [allCandidateList, setAllCandidateList] = useState([]);
  const [partnerCandidateList, setPartnerCandidateList] = useState([]);
  const [partnerListByType, setPartnerListByType] = useState([]);
  const [partnerType, setPartnerType] = useState("");
  const [selectedJsonData, setSelectedJsonData] = useState("");
  const [selectedPartnerId, setSelectedPartnerId] = useState("");
  const [subcontractorDdName] = useState("SubcontractorEnrollmentForm");
  const [recruiterDdName] = useState("RecruiterEnrollmentForm");
  const [candidateDdName] = useState("CandidateOnboardingForm");

  // New Search & Stats State
  const [searchTerm, setSearchTerm] = useState("");
  const [fieldSearchTerm, setFieldSearchTerm] = useState("");
  const [excelShowHide, setExcelShowHide] = useState(false);
  const [pdfShowHide, setPdfShowHide] = useState(false);
  const [selectedCol, setSelectedCol] = useState([]);
  const [selectedColData, setSelectedColData] = useState([]);
  const [subcontractorsCount, setSubcontractorsCount] = useState(0);
  const [recruitersCount, setRecruitersCount] = useState(0);
  const reportRef = useRef();

  const dataTypeApplicationReportsSelector = useSelector(getDataTypeApplicationReports);
  const allCandidateListSelector = useSelector(getAllCandidateList);
  const partnerListByTypeSelector = useSelector(getPartnerListByType);
  const applicationReportPartnerStatsSelector = useSelector(getApplicationReportPartnerStats);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Entity Data"));
    dispatch(setCurrentRoute(route));
  }, []);

  useEffect(() => {
    dispatch(loadDataTypeApplicationReports());
    dispatch(loadAllCandidateList());
    dispatch(loadApplicationReportPartnerStats("Sub-Contractors"));
    dispatch(loadApplicationReportPartnerStats("Recruiter"));
  }, []);

  useEffect(() => {
    setSubcontractorsCount(applicationReportPartnerStatsSelector?.subcontractors?.length || 0);
    setRecruitersCount(applicationReportPartnerStatsSelector?.recruiters?.length || 0);
  }, [applicationReportPartnerStatsSelector]);

  useEffect(() => {
    if (dataTypeApplicationReportsSelector.length > 0) {
      setAllReportData(dataTypeApplicationReportsSelector);
    }
  }, [dataTypeApplicationReportsSelector]);

  useEffect(() => {
    setAllCandidateList(allCandidateListSelector);
  }, [allCandidateListSelector]);

  useEffect(() => {
    setPartnerListByType(partnerListByTypeSelector);
  }, [partnerListByTypeSelector]);

  const getAttribute = (t) => {
    if (t?.data && t?.data !== "") {
      const items = JSON.parse(t.data);
      return items;
    }
    return [];
  };

  const getAttributeValue = (d, t, att) => {
    if (d?.appData && d.appData === "") return "";
    try {
      const itemValues = JSON.parse(d.appData);
      const appShortName = Object.keys(itemValues)[1];
      const items = itemValues[appShortName][t.name.toLowerCase()];
      return items && items["@" + att];
    } catch (e) {
      return "";
    }
  };

  const handleCategorySelect = (partType) => {
    setPartnerType(partType);
    let rptData = [];
    if (partType === "Sub-Contractors" || partType === "Recruiter") {
      dispatch(loadPartnerListByType(partType, 0));
      if (partType === "Sub-Contractors")
        rptData = allReportData.filter((x) => x.name === subcontractorDdName);
      if (partType === "Recruiter")
        rptData = allReportData.filter((x) => x.name === recruiterDdName);
      setReportData(rptData);
    } else {
      const filterCandidates = allCandidateList.filter((x) => x.registrationType === partType);
      setPartnerCandidateList(filterCandidates);
      rptData = allReportData.filter((x) => x.name === candidateDdName);
      setReportData(rptData);
    }
    setSelectedPartnerId("");
    setSelectedJsonData("");
    setSearchTerm("");
    setFieldSearchTerm("");
  };

  const handleSelectEntity = (id) => {
    let jsonData = "";
    const numId = parseInt(id);
    if (partnerType === "Sub-Contractors" || partnerType === "Recruiter") {
      const partner = partnerListByType.filter((x) => x.fuid === numId);
      if (partner.length > 0 && partner[0].contact1) {
        jsonData = partner[0].contact1.performerData;
      }
    } else {
      const perf = allCandidateList.filter((x) => x.performerid === numId);
      if (perf.length > 0) {
        jsonData = perf[0].performerData;
      }
    }
    setSelectedJsonData(jsonData);
    setSelectedPartnerId(numId);
    setFieldSearchTerm("");
  };

  // Compute reactive dashboard stats
  const w2Count = allCandidateList.filter(x => x.registrationType === "W2 Basis").length;
  const c2cCount = allCandidateList.filter(x => x.registrationType === "C2C Basis").length;
  const i1099Count = allCandidateList.filter(x => x.registrationType === "1099 Basis").length;
  const totalEntities = allCandidateList.length + subcontractorsCount + recruitersCount;

  // Selected profile details
  let selectedEntityName = "";
  let selectedEntityInitials = "";
  if (selectedPartnerId) {
    if (partnerType === "Sub-Contractors" || partnerType === "Recruiter") {
      const entity = partnerListByType.find((x) => x.fuid === selectedPartnerId);
      if (entity) selectedEntityName = entity.label;
    } else {
      const candidate = allCandidateList.find((x) => x.performerid === selectedPartnerId);
      if (candidate) selectedEntityName = `${candidate.performername || ""} ${candidate.lastName || ""}`.trim();
    }
    if (selectedEntityName) {
      selectedEntityInitials = selectedEntityName
        .split(" ")
        .map((n) => n[0])
        .join("")
        .substring(0, 2)
        .toUpperCase();
    } else {
      selectedEntityInitials = "??";
    }
  }

  // Filter lists based on search
  const getFilteredList = () => {
    if (partnerType === "Sub-Contractors" || partnerType === "Recruiter") {
      return partnerListByType.filter(item =>
        item.label && item.label.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else {
      return partnerCandidateList.filter(item => {
        const fullName = `${item.performername || ""} ${item.lastName || ""}`.trim();
        return fullName.toLowerCase().includes(searchTerm.toLowerCase());
      });
    }
  };

  // Charts configurations
  const candidateChartData = {
    label: ["W2 Hourly", "C2C Basis", "1099 Basis"],
    data: [w2Count, c2cCount, i1099Count]
  };

  const entityBarData = [
    {
      type: "Entity Count",
      label: ["Candidates", "Subcontractors", "Recruiters"],
      data: [allCandidateList.length, subcontractorsCount, recruitersCount]
    }
  ];

  const filteredEntities = getFilteredList();

  const handleexcelShowHide = () => {
    setExcelShowHide(false);
    setSelectedCol([]);
    setSelectedColData([]);
  };

  const handleExcelExport = () => {
    const headers = [["Field Metric", "Registered Value"]];
    const data = [];
    if (selectedJsonData) {
      reportData.forEach((t) => {
        getAttribute(t).forEach((m) => {
          data.push([
            m.Label,
            String(getAttributeValue({ appData: selectedJsonData }, t, m.Name) || "")
          ]);
        });
      });
    }
    setSelectedCol(headers);
    setSelectedColData(data);
    setExcelShowHide(true);
  };

  const handlepdfShowHide = () => {
    setPdfShowHide(false);
    setSelectedCol([]);
    setSelectedColData([]);
  };

  const handleExportPDF = () => {
    const headers = [["Field Metric", "Registered Value"]];
    const data = [];
    if (selectedJsonData) {
      reportData.forEach((t) => {
        getAttribute(t).forEach((m) => {
          data.push([
            m.Label,
            String(getAttributeValue({ appData: selectedJsonData }, t, m.Name) || "")
          ]);
        });
      });
    }
    setSelectedCol(headers);
    setSelectedColData(data);
    setPdfShowHide(true);
  };

  // Render GeneratePdf and GenerateExcel tags
  const renderExporters = () => (
    <>
      <GeneratePdf
        handlepdfShowHide={handlepdfShowHide}
        pdfShowHide={pdfShowHide}
        selectedCol={selectedCol}
        selectedColData={selectedColData}
      />
      <GenerateExcel
        handleexcelShowHide={handleexcelShowHide}
        excelShowHide={excelShowHide}
        selectedCol={selectedCol}
        selectedColData={selectedColData}
      />
    </>
  );

  return (
    <React.Fragment>
      <style>{`
        /* Pro UI Styling for ApplicationReport */
        .ar-hub {
          font-family: 'Inter', 'Open Sans', system-ui, -apple-system, sans-serif;
          background: #f8fafc;
          min-height: calc(100vh - 120px);
          padding: 8px 0;
        }

        .ar-card {
          background: #ffffff;
          border: 1px solid rgba(226, 232, 240, 0.8);
          border-radius: 16px;
          box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02), 0 2px 4px -1px rgba(0,0,0,0.01);
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .ar-card:hover {
          box-shadow: 0 12px 20px -3px rgba(0,0,0,0.05), 0 4px 6px -2px rgba(0,0,0,0.02);
        }

        /* ── Entity Hub Panel Header ── */
        .ar-panel-header {
          position: relative;
          padding: 22px 20px 18px;
          margin: -16px -16px 20px;
          background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%);
          border-bottom: 1px solid #e2e8f0;
          border-radius: 16px 16px 0 0;
          overflow: hidden;
        }

        .ar-panel-header::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          width: 4px;
          background: #4f46e5;
          border-radius: 4px 0 0 0;
        }

        .ar-panel-header-top {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .ar-panel-icon {
          width: 46px;
          height: 46px;
          border-radius: 12px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #ffffff;
          border: 1px solid rgba(79, 70, 229, 0.2);
          color: #4f46e5;
          font-size: 18px;
          flex-shrink: 0;
          box-shadow: 0 4px 12px -4px rgba(79, 70, 229, 0.18);
        }

        .ar-panel-title {
          font-size: 19px;
          font-weight: 800;
          color: #0f172a;
          letter-spacing: -0.02em;
          margin: 0;
          line-height: 1.2;
        }

        .ar-panel-subtitle {
          font-size: 12px;
          color: #64748b;
          font-weight: 500;
          margin-top: 2px;
        }

        .ar-panel-watermark {
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 52px;
          color: #4f46e5;
          opacity: 0.04;
          pointer-events: none;
        }

        .ar-section-label {
          font-size: 10px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          color: #94a3b8;
          margin-bottom: 10px;
          padding-left: 2px;
        }

        /* Category tabs */
        .ar-cat-menu {
          display: flex;
          flex-direction: column;
          gap: 4px;
          margin-bottom: 20px;
        }

        .ar-cat-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 11px 14px;
          border-radius: 10px;
          cursor: pointer;
          background: #ffffff;
          border: 1px solid transparent;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          font-weight: 600;
          font-size: 13px;
          color: #475569;
          position: relative;
        }

        .ar-cat-item:hover {
          background: #f8fafc;
          color: #1e293b;
          border-color: #e2e8f0;
          transform: translateX(3px);
        }

        .ar-cat-item.active {
          background: linear-gradient(135deg, rgba(79, 70, 229, 0.06) 0%, rgba(124, 58, 237, 0.03) 100%);
          border-color: rgba(79, 70, 229, 0.2);
          color: #4f46e5;
          box-shadow: 0 2px 8px -2px rgba(79, 70, 229, 0.1);
        }

        .ar-cat-item.active .ar-cat-icon-wrap {
          border-color: #4f46e5;
          box-shadow: 0 4px 8px -3px rgba(79, 70, 229, 0.25);
        }

        .ar-cat-icon-wrap {
          width: 34px;
          height: 34px;
          border-radius: 9px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          flex-shrink: 0;
          transition: all 0.2s ease;
          border: 1px solid #e2e8f0;
        }

        .ar-cat-label {
          flex: 1;
          min-width: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .ar-cat-count {
          font-size: 10px;
          font-weight: 800;
          padding: 2px 7px;
          border-radius: 999px;
          background: #f1f5f9;
          color: #64748b;
          border: 1px solid #e2e8f0;
          flex-shrink: 0;
          min-width: 24px;
          text-align: center;
          transition: all 0.2s ease;
        }

        .ar-cat-item.active .ar-cat-count {
          background: rgba(79, 70, 229, 0.08);
          color: #4f46e5;
          border-color: rgba(79, 70, 229, 0.15);
        }

        .ar-cat-divider {
          height: 1px;
          background: #e2e8f0;
          margin: 8px 0 14px;
        }

        /* Search input styling */
        .ar-search-wrapper {
          position: relative;
          margin-bottom: 14px;
        }

        .ar-search-input {
          width: 100%;
          padding: 10px 16px 10px 38px;
          background: #ffffff;
          border: 1px solid #cbd5e1;
          border-radius: 10px;
          font-size: 13px;
          color: #1e293b;
          transition: all 0.2s ease;
        }

        .ar-search-input:focus {
          outline: none;
          border-color: #4f46e5;
          box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
        }

        .ar-search-icon {
          position: absolute;
          left: 14px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 13px;
        }

        /* Entity list scrollable container */
        .ar-entity-list {
          max-height: 480px;
          overflow-y: auto;
          padding-right: 2px;
        }

        .ar-entity-list::-webkit-scrollbar {
          width: 5px;
        }

        .ar-entity-list::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }

        .ar-entity-item {
          display: flex;
          align-items: center;
          padding: 10px 12px;
          border-radius: 10px;
          cursor: pointer;
          margin-bottom: 6px;
          border: 1px solid transparent;
          transition: all 0.15s ease;
          background: #ffffff;
        }

        .ar-entity-item:hover {
          background: #f8fafc;
          transform: translateY(-1px);
          box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02);
        }

        .ar-entity-item.active {
          background: rgba(79, 70, 229, 0.05);
          border-color: rgba(79, 70, 229, 0.15);
        }

        .ar-avatar {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 12px;
          color: #ffffff;
          margin-right: 12px;
          flex-shrink: 0;
          box-shadow: inset 0 -2px 0 rgba(0,0,0,0.1);
        }

        .ar-entity-name {
          font-weight: 700;
          font-size: 13px;
          color: #1e293b;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .ar-entity-sub {
          font-size: 11px;
          color: #64748b;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        /* Hero Header */
        .ar-hero-header {
          background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);
          border: 1px solid rgba(15, 23, 42, 0.08);
          border-radius: 18px;
          color: #1e293b;
          margin-bottom: 24px;
          padding: 30px 32px 26px;
          position: relative;
          overflow: hidden;
          box-shadow:
            0 1px 3px rgba(15, 23, 42, 0.02),
            0 8px 24px rgba(15, 23, 42, 0.04),
            inset 0 1px 0 #ffffff;
        }

        .ar-hero-kicker {
          color: #4f46e5;
          font-size: 11px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 8px;
        }

        .ar-hero-title-main {
          font-size: 28px;
          font-weight: 800;
          color: #0f172a;
          letter-spacing: -0.02em;
          margin-bottom: 10px;
          line-height: 1.2;
        }

        .ar-hero-copy {
          font-size: 13.5px;
          color: #475569;
          line-height: 1.6;
          margin-bottom: 0;
          max-width: 720px;
        }

        .ar-hero-watermark {
          position: absolute;
          right: 28px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 72px;
          color: #4f46e5;
          opacity: 0.05;
          pointer-events: none;
        }

        /* Dashboard Metrics */
        .ar-kpi-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
          gap: 16px;
          margin-bottom: 24px;
        }

        .ar-kpi-card {
          padding: 16px 20px;
          display: flex;
          align-items: center;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 14px;
        }

        .ar-kpi-icon-wrapper {
          width: 44px;
          height: 44px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          margin-right: 14px;
          flex-shrink: 0;
        }

        .ar-kpi-num {
          font-size: 22px;
          font-weight: 800;
          color: #0f172a;
          line-height: 1.1;
          margin-bottom: 2px;
        }

        .ar-kpi-label {
          font-size: 11.5px;
          color: #64748b;
          font-weight: 600;
        }

        /* Detailed Report View styling */
        .ar-detail-view {
          overflow: hidden;
        }

        .ar-hero {
          background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 50%, #e2e8f0 100%);
          padding: 24px 28px;
          color: #0f172a;
          position: relative;
          overflow: hidden;
          border-bottom: 1px solid #e2e8f0;
        }

        .ar-hero-glow {
          position: absolute;
          top: -40px;
          right: -40px;
          width: 180px;
          height: 180px;
          background: radial-gradient(circle, rgba(79, 70, 229, 0.06) 0%, transparent 70%);
          border-radius: 50%;
        }

        .ar-hero-body {
          display: flex;
          align-items: center;
          position: relative;
          z-index: 1;
        }

        .ar-hero-avatar {
          width: 62px;
          height: 62px;
          border-radius: 50%;
          background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
          border: 2px solid rgba(79, 70, 229, 0.25);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          font-weight: 800;
          color: #4f46e5;
          margin-right: 18px;
          box-shadow: 0 4px 12px -3px rgba(79, 70, 229, 0.15);
        }

        .ar-hero-name {
          font-size: 20px;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 2px;
          letter-spacing: -0.01em;
        }

        .ar-hero-badge {
          display: inline-block;
          padding: 3px 9px;
          background: rgba(79, 70, 229, 0.08);
          border-radius: 30px;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          color: #4f46e5;
          border: 1px solid rgba(79, 70, 229, 0.15);
        }

        .ar-actions-bar {
          background: #fdfdfd;
          border-bottom: 1px solid #e2e8f0;
          padding: 12px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 12px;
        }

        .ar-actions-btns {
          display: flex;
          align-items: center;
        }

        .ar-actions-btns > * {
          margin-right: 8px !important;
        }

        .ar-actions-btns > *:last-child {
          margin-right: 0 !important;
        }

        .ar-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          padding: 6px 12px;
          font-size: 12.5px;
          font-weight: 600;
          border-radius: 8px;
          border: 1px solid #cbd5e1;
          background: #ffffff;
          color: #334155;
          transition: all 0.15s ease;
          cursor: pointer;
        }

        .ar-btn:hover:not(:disabled) {
          background: #f8fafc;
          color: #0f172a;
          border-color: #94a3b8;
        }

        .ar-btn-primary {
          background: #4f46e5;
          color: #ffffff;
          border-color: #4f46e5;
        }

        .ar-btn-primary:hover:not(:disabled) {
          background: #4338ca;
          color: #ffffff;
          border-color: #4338ca;
        }

        .ar-report-grid {
          padding: 24px;
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 14px;
          background: #ffffff;
        }

        .ar-field-card {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 10px;
          padding: 12px 14px;
          display: flex;
          flex-direction: column;
          transition: all 0.15s ease;
        }

        .ar-field-card:hover {
          border-color: #cbd5e1;
          background: #ffffff;
          box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02);
        }

        .ar-field-label {
          font-size: 10.5px;
          font-weight: 700;
          text-transform: uppercase;
          color: #94a3b8;
          margin-bottom: 4px;
          letter-spacing: 0.05em;
        }

        .ar-field-value {
          font-size: 13.5px;
          font-weight: 600;
          color: #334155;
          word-break: break-all;
        }

        /* Print stylesheet */
        @media print {
          body * {
            visibility: hidden;
          }
          .ar-detail-view, .ar-detail-view * {
            visibility: visible;
          }
          .ar-detail-view {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
          }
          .ar-actions-bar {
            display: none !important;
          }
        }
      `}</style>

      <div className="ar-hub">
        <Row>
          {/* Left Panel: Category & Entity Selector */}
          <Col lg={4} className="mb-4">
            <Card className="ar-card p-3 h-100">
              {/* Premium Panel Header */}
              <div className="ar-panel-header">
                <div className="ar-panel-header-top">
                  <div className="ar-panel-icon">
                    <i className="fa fa-th-large" aria-hidden="true" />
                  </div>
                  <div>
                    <h2 className="ar-panel-title">Entity Hub</h2>
                    <div className="ar-panel-subtitle">
                      Browse &amp; inspect entity records
                      {allCandidateList.length === 0 && (
                        <span className="spinner-border spinner-border-sm text-primary ml-2" style={{ width: "12px", height: "12px", borderWidth: "2px" }} role="status"></span>
                      )}
                    </div>
                  </div>
                </div>
                <i className="fa fa-sitemap ar-panel-watermark" aria-hidden="true" />
              </div>

              {/* Section Label */}
              <div className="ar-section-label">Select Category</div>

              {/* Vertical Category Selector Tabs */}
              <div className="ar-cat-menu">
                <div
                  className={`ar-cat-item ${partnerType === "W2 Basis" ? "active" : ""}`}
                  onClick={() => handleCategorySelect("W2 Basis")}
                >
                  <div className="ar-cat-icon-wrap" style={{ background: "rgba(59, 130, 246, 0.08)", color: "#3b82f6" }}>
                    <i className="fa fa-user" aria-hidden="true" />
                  </div>
                  <span className="ar-cat-label">W2 Hourly Candidates</span>
                  <span className="ar-cat-count">{w2Count}</span>
                </div>
                <div
                  className={`ar-cat-item ${partnerType === "C2C Basis" ? "active" : ""}`}
                  onClick={() => handleCategorySelect("C2C Basis")}
                >
                  <div className="ar-cat-icon-wrap" style={{ background: "rgba(6, 182, 212, 0.08)", color: "#06b6d4" }}>
                    <i className="fa fa-building-o" aria-hidden="true" />
                  </div>
                  <span className="ar-cat-label">C2C Candidates</span>
                  <span className="ar-cat-count">{c2cCount}</span>
                </div>
                <div
                  className={`ar-cat-item ${partnerType === "1099 Basis" ? "active" : ""}`}
                  onClick={() => handleCategorySelect("1099 Basis")}
                >
                  <div className="ar-cat-icon-wrap" style={{ background: "rgba(16, 185, 129, 0.08)", color: "#10b981" }}>
                    <i className="fa fa-user-circle-o" aria-hidden="true" />
                  </div>
                  <span className="ar-cat-label">1099 Candidates</span>
                  <span className="ar-cat-count">{i1099Count}</span>
                </div>

                <div className="ar-cat-divider" />

                <div
                  className={`ar-cat-item ${partnerType === "Sub-Contractors" ? "active" : ""}`}
                  onClick={() => handleCategorySelect("Sub-Contractors")}
                >
                  <div className="ar-cat-icon-wrap" style={{ background: "rgba(245, 158, 11, 0.08)", color: "#f59e0b" }}>
                    <i className="fa fa-handshake-o" aria-hidden="true" />
                  </div>
                  <span className="ar-cat-label">Subcontractors</span>
                  <span className="ar-cat-count">{subcontractorsCount}</span>
                </div>
                <div
                  className={`ar-cat-item ${partnerType === "Recruiter" ? "active" : ""}`}
                  onClick={() => handleCategorySelect("Recruiter")}
                >
                  <div className="ar-cat-icon-wrap" style={{ background: "rgba(239, 68, 68, 0.08)", color: "#ef4444" }}>
                    <i className="fa fa-briefcase" aria-hidden="true" />
                  </div>
                  <span className="ar-cat-label">Recruiters</span>
                  <span className="ar-cat-count">{recruitersCount}</span>
                </div>
              </div>

              {/* List of Entities belonging to selected category */}
              {partnerType !== "" && (
                <React.Fragment>
                  <div className="ar-search-wrapper">
                    <i className="fa fa-search ar-search-icon"></i>
                    <input
                      type="text"
                      placeholder={`Search ${partnerType === "Sub-Contractors"
                        ? "Subcontractors"
                        : partnerType === "Recruiter"
                          ? "Recruiters"
                          : "Candidates"
                        }...`}
                      className="ar-search-input"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>

                  <div className="ar-entity-list">
                    {filteredEntities.length > 0 ? (
                      filteredEntities.map((item) => {
                        const id =
                          partnerType === "Sub-Contractors" || partnerType === "Recruiter"
                            ? item.fuid
                            : item.performerid;
                        const name =
                          partnerType === "Sub-Contractors" || partnerType === "Recruiter"
                            ? item.label
                            : `${item.performername || ""} ${item?.lastName || ""}`.trim();
                        const email =
                          partnerType === "Sub-Contractors" || partnerType === "Recruiter"
                            ? item.contact1?.email || "No email provided"
                            : item.email || "No email provided";

                        const initials = name
                          .split(" ")
                          .map((n) => n[0])
                          .join("")
                          .substring(0, 2)
                          .toUpperCase();

                        const colors = ["#4f46e5", "#0ea5e9", "#10b981", "#f59e0b", "#ec4899", "#8b5cf6"];
                        const avatarBg = colors[name.length % colors.length];

                        return (
                          <div
                            key={id}
                            className={`ar-entity-item ${selectedPartnerId === id ? "active" : ""}`}
                            onClick={() => handleSelectEntity(id)}
                          >
                            <div className="ar-avatar" style={{ backgroundColor: avatarBg }}>
                              {initials}
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div className="ar-entity-name">{name}</div>
                              <div className="ar-entity-sub">{email}</div>
                            </div>
                            <div>
                              <i className="fa fa-angle-right" style={{ color: "#cbd5e1" }}></i>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center py-4 text-muted">
                        <i className="fa fa-folder-open-o fa-2x mb-2 d-block"></i>
                        <small>No records matched your search</small>
                      </div>
                    )}
                  </div>
                </React.Fragment>
              )}
            </Card>
          </Col>

          {/* Right Panel: Analytics Dashboard OR Report detailed view */}
          <Col lg={8} className="mb-4">
            {!selectedPartnerId ? (
              /* LANDING DASHBOARD */
              <div className="animate-fade-in">
                <div className="ar-hero-header">
                  <div className="ar-hero-kicker">ENTITY DATA ANALYTICS</div>
                  <h1 className="ar-hero-title-main">Entity Hub Analytics</h1>
                  <p className="ar-hero-copy">
                    Welcome to the Entity Analytics &amp; Form Hub. Select an entity category to inspect records, or review aggregate workforce metrics below.
                  </p>
                  <i className="fa fa-database ar-hero-watermark" aria-hidden="true"></i>
                </div>

                {/* KPI Metrics */}
                <div className="ar-kpi-grid">
                  <div className="ar-kpi-card ar-card">
                    <div className="ar-kpi-icon-wrapper" style={{ background: "rgba(99, 102, 241, 0.08)", color: "#4f46e5" }}>
                      <i className="fa fa-users"></i>
                    </div>
                    <div>
                      <div className="ar-kpi-num">{totalEntities}</div>
                      <div className="ar-kpi-label">Total Entities</div>
                    </div>
                  </div>

                  <div className="ar-kpi-card ar-card">
                    <div className="ar-kpi-icon-wrapper" style={{ background: "rgba(16, 185, 129, 0.08)", color: "#10b981" }}>
                      <i className="fa fa-graduation-cap"></i>
                    </div>
                    <div>
                      <div className="ar-kpi-num">{allCandidateList.length}</div>
                      <div className="ar-kpi-label">Candidates</div>
                    </div>
                  </div>

                  <div className="ar-kpi-card ar-card">
                    <div className="ar-kpi-icon-wrapper" style={{ background: "rgba(14, 165, 233, 0.08)", color: "#0ea5e9" }}>
                      <i className="fa fa-handshake-o"></i>
                    </div>
                    <div>
                      <div className="ar-kpi-num">{subcontractorsCount}</div>
                      <div className="ar-kpi-label">Subcontractors</div>
                    </div>
                  </div>

                  <div className="ar-kpi-card ar-card">
                    <div className="ar-kpi-icon-wrapper" style={{ background: "rgba(245, 158, 11, 0.08)", color: "#f59e0b" }}>
                      <i className="fa fa-briefcase"></i>
                    </div>
                    <div>
                      <div className="ar-kpi-num">{recruitersCount}</div>
                      <div className="ar-kpi-label">Recruiters</div>
                    </div>
                  </div>
                </div>

                {/* Charts Section */}
                <Row>
                  <Col md={6} className="mb-4">
                    <Card className="ar-card p-3 h-100">
                      <h3 style={{ fontSize: "14px", fontWeight: 700 }} className="mb-3 text-muted uppercase">
                        Candidates Breakdown
                      </h3>
                      {allCandidateList.length > 0 ? (
                        <PieChart graphData={candidateChartData} />
                      ) : (
                        <div className="text-center py-5 text-muted"><small>Loading chart data...</small></div>
                      )}
                    </Card>
                  </Col>
                  <Col md={6} className="mb-4">
                    <Card className="ar-card p-3 h-100">
                      <h3 style={{ fontSize: "14px", fontWeight: 700 }} className="mb-3 text-muted uppercase">
                        Entity Distribution
                      </h3>
                      {allCandidateList.length > 0 ? (
                        <BarChart graphData={entityBarData} />
                      ) : (
                        <div className="text-center py-5 text-muted"><small>Loading chart data...</small></div>
                      )}
                    </Card>
                  </Col>
                </Row>
              </div>
            ) : (
              /* DETAILED PROFILE REPORT VIEW */
              <div className="ar-detail-view ar-card animate-fade-in">
                {/* Hero Gradient Block */}
                <div className="ar-hero">
                  <div className="ar-hero-glow"></div>
                  <div className="ar-hero-body">
                    <div className="ar-hero-avatar">{selectedEntityInitials}</div>
                    <div>
                      <h2 className="ar-hero-name mb-1">{selectedEntityName}</h2>
                      <span className="ar-hero-badge">
                        {partnerType === "Sub-Contractors" ? "Subcontractor" : partnerType === "Recruiter" ? "Recruiter" : partnerType}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Actions & Filters */}
                <div className="ar-actions-bar">
                  <div className="d-flex align-items-center">
                    <div style={{ position: "relative", width: "220px" }}>
                      <i className="fa fa-search ar-search-icon" style={{ left: "12px" }}></i>
                      <input
                        type="text"
                        placeholder="Search report fields..."
                        className="form-control form-control-sm"
                        style={{ paddingLeft: "32px", fontSize: "13px", height: "34px", borderRadius: "8px" }}
                        value={fieldSearchTerm}
                        onChange={(e) => setFieldSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="ar-actions-btns">
                    {/* Excel Export component */}
                    <button
                            type="button"
                            className="ar-btn"
                            disabled={!selectedJsonData}
                            onClick={handleExcelExport}
                        >
                            <i className="fa fa-file-excel-o" style={{ color: "#10b981", marginRight: "6px" }} aria-hidden="true"></i>
                            Excel Export
                        </button>

                    {/* PDF Export Component */}
                    <button
                      type="button"
                      className="ar-btn ar-btn-primary"
                      disabled={!selectedJsonData}
                      onClick={handleExportPDF}
                    >
                      <i className="fa fa-file-pdf-o" style={{ marginRight: "6px" }} aria-hidden="true"></i>
                      Export PDF
                    </button>
                  </div>
                </div>

                {/* Detailed Responsive Cards Grid */}
                <div ref={reportRef} className="ar-report-grid">
                  {selectedJsonData ? (
                    reportData.map((t) => {
                      const attributes = getAttribute(t);
                      const filteredAttributes = attributes.filter(
                        (m) =>
                          m.Label.toLowerCase().includes(fieldSearchTerm.toLowerCase()) ||
                          String(getAttributeValue({ appData: selectedJsonData }, t, m.Name) || "")
                            .toLowerCase()
                            .includes(fieldSearchTerm.toLowerCase())
                      );

                      if (filteredAttributes.length === 0) {
                        return (
                          <div className="col-12 text-center py-5 text-muted" key={t.name}>
                            <i className="fa fa-search-plus fa-2x mb-2 d-block"></i>
                            <small>No matching report fields found</small>
                          </div>
                        );
                      }

                      return filteredAttributes.map((m) => {
                        const val = getAttributeValue({ appData: selectedJsonData }, t, m.Name);
                        return (
                          <div className="ar-field-card" key={m.Name}>
                            <span className="ar-field-label">{m.Label}</span>
                            <span className="ar-field-value">
                              {val || <em className="text-muted" style={{ fontWeight: 400 }}>Not Provided</em>}
                            </span>
                          </div>
                        );
                      });
                    })
                  ) : (
                    <div className="col-12 text-center py-5">
                      <span className="spinner-border text-primary d-block mx-auto mb-3" role="status"></span>
                      <small className="text-muted">Loading entity profile details...</small>
                    </div>
                  )}
                </div>
              </div>
            )}
          </Col>
        </Row>
      </div>
      {renderExporters()}
    </React.Fragment>
  );
};

export default ApplicationReport;
